import React, { useState } from "react";
import api from "../../utils/api/axiosInstance";
import { FaUser, FaEnvelope, FaCommentDots, FaPaperPlane } from "react-icons/fa";
import PageSeo from "../../components/common/PageSeo";
import styles from "../../styles/pages/static/ContactPage.module.css";

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [status, setStatus] = useState(null);
  const [statusType, setStatusType] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setStatus(null);

    try {
      await api.post("/contact", formData);
      setStatus("Message sent successfully! We'll get back to you soon.");
      setStatusType("success");
      setFormData({ name: "", email: "", message: "" });
    } catch (err) {
      console.error("❌ Contact form error:", err);
      setStatus("Failed to send message. Please try again later.");
      setStatusType("error");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="pageContainer">
      <PageSeo
        title="Contact Us"
        description="Have a question or feedback? Contact the Simpary team and we'll get back to you soon."
        pathname="/contact"
      />
      <div className="innerContainer">
        <div className={styles.contactPage}>
        {/* Header Section */}
        <section className={styles.headerSection}>
          <div className={styles.headerContent}>
            <h1 className={styles.pageTitle}>Get In Touch</h1>
            <p className={styles.pageSubtitle}>
              Have a question or feedback? We'd love to hear from you. 
              Send us a message and we'll respond as soon as possible.
            </p>
          </div>
        </section>

        {/* Contact Form Section */}
        <section className={styles.formSection}>
          <div className={styles.formContainer}>
            <form className={styles.contactForm} onSubmit={handleSubmit}>
              {/* Name Field */}
              <div className={styles.formGroup}>
                <label htmlFor="name" className={styles.formLabel}>
                  <FaUser className={styles.labelIcon} />
                  Your Name
                </label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  className={styles.formInput}
                  placeholder="Enter your full name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                />
              </div>

              {/* Email Field */}
              <div className={styles.formGroup}>
                <label htmlFor="email" className={styles.formLabel}>
                  <FaEnvelope className={styles.labelIcon} />
                  Email Address
                </label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  className={styles.formInput}
                  placeholder="Enter your email address"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                />
              </div>

              {/* Message Field */}
              <div className={styles.formGroup}>
                <label htmlFor="message" className={styles.formLabel}>
                  <FaCommentDots className={styles.labelIcon} />
                  Your Message
                </label>
                <textarea
                  id="message"
                  name="message"
                  className={styles.formTextarea}
                  placeholder="Tell us what's on your mind..."
                  rows={6}
                  value={formData.message}
                  onChange={handleChange}
                  required
                  disabled={isLoading}
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                className={styles.submitButton}
                disabled={isLoading}
              >
                {isLoading ? (
                  <>
                    <span className={styles.spinner}></span>
                    Sending...
                  </>
                ) : (
                  <>
                    <FaPaperPlane className={styles.buttonIcon} />
                    Send Message
                  </>
                )}
              </button>

              {/* Status Message */}
              {status && (
                <div
                  className={`${styles.statusMessage} ${
                    statusType === "success"
                      ? styles.statusSuccess
                      : styles.statusError
                  }`}
                >
                  {status}
                </div>
              )}
            </form>
          </div>
        </section>
        </div>
      </div>
    </div>
  );
};

export default ContactPage;
